/** Tipos de acto jurídico → roles permitidos por operación (prototipo ModuloFirmantes). */
export const CATALOGO_OPERACIONES = {
    CONSTITUTIVA: ['SOCIO FUNDADOR', 'OTRO'],
    'COMPRAVENTA DE ACCIONES': ['VENDEDOR', 'COMPRADOR'],
    'AUMENTO O DISMINUCIÓN DE CAPITAL': ['APORTANTE', 'SOCIO DILUIDO'],
    'RATIFICACIÓN DE CRÉDITOS': ['ACREEDOR', 'DEUDOR'],
    FUSIÓN: ['SOCIEDAD FUSIONADA', 'SOCIEDAD FUSIONANTE', 'SOCIEDAD RESULTANTE'],
    ESCISIÓN: ['SOCIEDAD ESCINDENTE', 'SOCIEDAD ESCINDIDA', 'SOCIEDAD RESULTANTE'],
    // 'DISOLUCIÓN Y LIQUIDACIÓN': ['SOCIEDAD DISUELTA'],
    'INMOBILIARIO': ['VENDEDOR', 'COMPRADOR', 'OTRO'],
};
